import { createSelector } from 'reselect';
import { ILocationState } from './types';

const selectLocationState = (state: { location: ILocationState }) => state.location;

export const selectLocationList = createSelector(
  selectLocationState,
  (locationState) => locationState.list.results
);

export const selectLocationListLoading = createSelector(
  selectLocationState,
  (locationState) => locationState.loading
);

export const selectLocationListError = createSelector(
  selectLocationState,
  (locationState) => locationState.error
);

export const selectLocationListCount = createSelector(
  selectLocationState,
  (locationState) => locationState.list.count
);
